import { shape, number, string, bool } from 'prop-types'
import genieSettingsType from './genieSettingsType'

export default shape({
  rid:                   number,
  active:                bool,
  blockedAt:             number,
  email:                 string,
  genieSettings:         genieSettingsType,
  adminGeniePath:        string,
  link:                  string,
  isLendingManager:      bool,
  isAccountManager:      bool,
  isRelationshipManager: bool
})
